import React, { useEffect, useRef, useState } from 'react';
import { Button, Dropdown, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { allBranchDetail, allDoctorDetail, allDoctorSearchDetail, allProblemDetail, allProblemSearchDetail, appointementCreate, leadGet, patientData, patientSearchData, searchLead, viewLead } from '../../../redux/actions/Files.action';
import { useDispatch, useSelector } from 'react-redux';
import { searchDoctor } from '../../../redux/actions/Master.action';
import { Formik, Field, ErrorMessage, useFormik } from 'formik';
import * as Yup from 'yup';
import logo from "assets/img/Sculpt-logo.png";
import { useLocation } from 'react-router-dom';

const validationSchema = Yup.object({
  patientId: Yup.string().required('Patient is required'),
  dateOfAppointment: Yup.date()
    .required('Date of appointment is required')
    .nullable(),
  notification: Yup.array().min(1, 'At least one notification method must be selected').required('This field is required'),
});

const initialValues = {
  patientId: '',
  dateOfAppointment: '',
  notification: [],
}
const AppoinmentModel = ({ show, toggle, currentDate }) => {
  const location = useLocation();
  const { userData } = location.state || {};
  const dropdownRef = useRef(null);
  const leadData = useSelector((state) => state.files);

  const [mainPage, setMainPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState('');
  const [selectedDoctorId, setSelectedDoctorId] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [problemData, setProblemData] = useState(false);
  const [selectedProblem, setSelectedProblem] = useState('');
  const [branchAdd, setBranchAdd] = useState('')
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
  });

  const limits = {
    page: mainPage,
    limit: 10,
  };
  const [userData1, setUserData1] = useState(false);
  const [doctorData1, setDoctorData1] = useState(false);
  const [searchType, setSearchType] = useState('doctor');
  const closeToggle = () => {
    toggle()
    setFormData({
      patientId: '',
      firstName: '',
      middleName: '',
      lastName: '',
      phoneNumber: '',
      branch: '',
      doctorName: '',
      remark: '',
      problem: '',
      dateOfAppointment: '',
      bookingType: '',
      subReference: '',
      branchAddress: '',
      notification: [],
    })
  }

  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    patientId: userData?._id || '',
    firstName: userData?.firstName || '',
    middleName: userData?.middleName || '',
    lastName: userData?.lastName || '',
    phoneNumber: userData?.phoneNumber || '',
    branch: userData?.branch || '',
    doctorName: userData?.doctorName || '',
    remark: userData?.remark || '',
    problem: userData?.problem || '',
    dateOfAppointment: '',
    bookingType: '',
    subReference: '',
    branchAddress: '',
    notification: [],
  });

  const handleData = (e) => {
    const { name, value, checked } = e.target;

    if (name === 'notification') {
      if (checked) {
        setFormData((prev) => ({
          ...prev,
          notification: [...prev.notification, value],
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          notification: prev.notification.filter((item) => item !== value),
        }));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const selectDoctor = (
    id,
    firstName,
    middleName,
    lastName,
    phoneNumber,
    branch,
    doctorName,
    remark,
    problem,
    setFieldValue
  ) => {
    setSelectedDoctor(firstName);
    setUserData1(false);
    setSearchQuery('');
    setSearchDefault({ page: '', search: '' });
    dispatch(viewLead(id));
    setFieldValue('patientId', id);
    setFieldValue('firstName', firstName);
    setFieldValue('middleName', middleName);
    setFieldValue('lastName', lastName);
    setFieldValue('phoneNumber', phoneNumber);
    setFieldValue('branch', branch);
    setFieldValue('doctorName', doctorName);
    setFieldValue('remark', remark);
    setFieldValue('problem', problem);
    if (branch) {
      const selectedBranch = leadData?.allBranch?.data?.Branches?.find(
        (b) => b.branchName === branch
      );
      setFieldValue('branchAddress', selectedBranch?.branchLocation || '');
    }
    if (doctorName && leadData?.allDoctor?.data?.doctor) {
      const doctor = leadData?.allDoctor?.data?.doctor.find(
        (doc) => doc.name === doctorName
      );
      if (doctor) {
        setSelectedDoctorId(doctor._id);
      } else {
        console.log('No matching doctor found for', doctorName);
      }
    }
  };

  useEffect(() => {
    if (userData) {
      let selectedBranch = ''
      if (userData?.branch) {
        selectedBranch = leadData?.allBranch?.data?.Branches?.find(
          (b) => b.branchName === userData?.branch
        );
      }
      setFormData(prev => ({
        ...prev,
        patientId: userData._id,
        firstName: userData.firstName,
        middleName: userData.middleName,
        lastName: userData.lastName,
        phoneNumber: userData.phoneNumber,
        branch: userData.branch,
        doctorName: userData.doctorName,
        remark: userData.remark,
        problem: userData.problem,
        branchAddress: selectedBranch?.branchLocation
      }));
      if (userData.doctorName && leadData?.allDoctor?.data?.doctor) {
        const doctor = leadData?.allDoctor?.data?.doctor.find(
          (doc) => doc.name === userData.doctorName
        );
        if (doctor) {
          setSelectedDoctorId(doctor._id);
        } else {
          console.log('No matching doctor found for', userData.doctorName);
        }
      }
    }
  }, [userData, leadData]);

  const handleAppointment = (values, { resetForm }) => {
    setLoader(true);
    const payload = {
      patientId: values.patientId,
      dateOfAppointment: values.dateOfAppointment,
      bookingType: values.bookingType,
      subReference: values.subReference,
      branchAddress: values.branchAddress,
      remark: values.remark,
      notification: values.notification,
      doctor: values.doctorName,
      doctorId: selectedDoctorId
    };
    const data = {
      date: currentDate
    };
    dispatch(appointementCreate(payload, currentDate, limits, data)).then(() => {
      toggle();
      resetForm({
        values: {
          patientId: '',  
          dateOfAppointment: '',
          bookingType: '',
          subReference: '',
          branchAddress: '',
          remark: '',
          notification: '',
          doctorName: ''
        }
      });
      setLoader(false);
    });
  };

  const searchData = (e, setFieldValue) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    setFieldValue('patientId', '')
    setFieldValue('problem', '')
    setFieldValue('doctor', '')
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
      page: mainPage,
    };
    setSearchDefault(newSearchParams);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    if (searchType === 'doctor') {
      dispatch(allDoctorSearchDetail(newSearchQuery))
    }
    if (searchType === 'problem') {
      dispatch(allProblemSearchDetail(newSearchQuery))
    }
    dispatch(patientSearchData(newSearchQuery))
  }

  const handleBranchChange = (e, setFieldValue) => {
    const selectedBranch = e.target.value;
    setFieldValue('branch', selectedBranch);

    const branchDetails = leadData?.allBranch?.data?.Branches?.find(
      (b) => b.branchName === selectedBranch
    );
    setFieldValue('branchAddress', branchDetails?.branchLocation || '');
  };

  const selectProblem = (problemName) => {
    setSelectedProblem(problemName);
    setProblemData(false);
    setSearchQuery('');
    setSearchDefault({ page: '', search: '' });
    setFormData((prevValues) => ({
      ...prevValues,
      problem: problemName,
    }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSelectedDoctor('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    dispatch(leadGet(limits))
    dispatch(patientData())
    dispatch(allDoctorDetail())
    dispatch(allProblemDetail())
    dispatch(allBranchDetail())
  }, [])


  return (
    <>
      {loader && (
        <div className="loaderAdd">
          <div className="loader_line"><img src={logo} className="w-[130px]" /></div>
        </div>
      )}
      <Modal show={show} onHide={closeToggle} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Add Appointment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={formData}
            validationSchema={validationSchema}
            onSubmit={handleAppointment}
          >
            {({ handleSubmit, setFieldValue, values }) => (
              <Form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-4 col-md-4">
                    <Form.Group controlId="campaignDetail">
                      <Form.Label>Patient Name</Form.Label>
                      <div className="relative" ref={dropdownRef}>
                        <div
                          className="border w-full border-theme-dark rounded py-[6px] px-[12px]"
                          onClick={() => {
                            setUserData1(!userData1);
                            setSearchType('person');
                          }}
                        >
                          {selectedDoctor ? selectedDoctor : 'Select Patient'}
                        </div>

                        <div
                          className={`${userData1
                            ? 'opacity-100 visible'
                            : 'opacity-0 invisible'
                            } absolute w-full border top-full h-[180px] overflow-auto z-10 left-0 rounded p-2 bg-white`}
                        >
                          <input
                            type="text"
                            name="search"
                            value={searchQuery}
                            placeholder={`Search Patient..`}
                            onChange={(e) => {
                              setFieldValue('patientId', e.target.value)
                              searchData(e, setFieldValue);
                            }}
                            className="w-full border p-2 rounded outline-none"
                          />
                          {leadData?.allPatient?.data?.PatientData?.map((res) => {
                            return (
                              <p
                                key={res._id}
                                value={res.name}
                                onClick={() => {
                                  selectDoctor(
                                    res._id,
                                    res.firstName,
                                    res.middleName,
                                    res.lastName,
                                    res.phoneNumber,
                                    res.branch,
                                    res.doctorName,
                                    res.remark,
                                    res.problem,
                                    setFieldValue
                                  ); dispatch(patientSearchData({ page: '', search: '' }))}
                                }
                                className="text-gray-400 cursor-pointer py-1 hover:text-black"
                              >
                                {res.firstName} {res.lastName}
                              </p>
                            );
                          })}
                        </div>
                      </div>
                      <ErrorMessage
                        name="patientId"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-4">
                    <Form.Group className="mb-3" controlId="firstName">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="firstName"
                        value={values.firstName}
                        disabled
                        placeholder="Enter First Name"
                        className="shadow-none focus:!border-theme-dark"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-4">
                    <Form.Group className="mb-3" controlId="middleName">
                      <Form.Label>Middle Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="middleName"
                        disabled
                        value={values.middleName}
                        placeholder="Enter Middle Name"
                        className="shadow-none focus:!border-theme-dark"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-4">
                    <Form.Group className="mb-3" controlId="lastName">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="lastName"
                        disabled
                        value={values.lastName}
                        placeholder="Enter Last Name"
                        className="shadow-none focus:!border-theme-dark"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-4">
                    <Form.Group className="mb-3" controlId="phoneNumber">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="nuber"
                        name="phoneNumber"
                        disabled
                        value={values.phoneNumber}
                        placeholder="Enter Phone Number"
                        className="shadow-none focus:!border-theme-dark"
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-4">
                    <Form.Group className="mb-3" controlId="date">
                      <Form.Label> Date of appointment</Form.Label>
                      <Form.Control
                        type="datetime-local"
                        name="dateOfAppointment"
                        onChange={(e) => {
                          setFieldValue('dateOfAppointment', e.target.value)
                          handleData(e);
                        }}
                        value={values.dateOfAppointment}
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="dateOfAppointment"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-4">
                    <Form.Group className="mb-3" controlId="problem">
                      <Form.Label>Consult </Form.Label>
                      <div className="relative">
                        <input
                          readOnly
                          placeholder="Select Consult"
                          className="border outline-none w-full border-theme-dark rounded py-[6px] px-[12px]"
                          name="problem"
                          onClick={() => {
                            setProblemData(!problemData);
                            setSearchType('problem')
                          }}
                          onChange={(e) =>
                            setFieldValue('problem', e.target.value)
                          }
                          value={values.problem}
                        />
                        {/* Default placeholder option */}
                        <div
                          className={`${problemData
                            ? 'opacity-100 visible'
                            : 'opacity-0 invisible'
                            } absolute w-full border top-full h-[180px] overflow-auto left-0 rounded p-2 bg-white`}
                        >
                          <input
                            type="text"
                            name="search"
                            value={searchQuery}
                            placeholder={`Search Consult`}
                            onChange={(e) => {
                              setFieldValue('problem', e.target.value)
                              searchData(e, setFieldValue);
                            }}
                            className="w-full border p-2 rounded outline-none"
                          />

                          {leadData?.allProblem?.data?.Problem?.map((res) => {
                            return (
                              <p
                                key={res._id}
                                onClick={() => {
                                  selectProblem(res.problem);
                                  setFieldValue('problem', res.problem);
                                }}
                                className="text-gray-700 py-1 cursor-pointer"
                              >
                                {res.problem}
                              </p>
                            );
                          })}
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-4">
                    <Form.Group className="mb-3" controlId="source">
                      <Form.Label>Booking Type</Form.Label>
                      <Form.Select
                        placeholder="Select Booking Type"
                        className="shadow-none focus:!border-theme-dark"
                        name="bookingType"
                        onChange={(e) => setFieldValue('bookingType', e.target.value)}
                        value={values.bookingType}
                      >
                        <option value="" disabled selected>
                          Select Booking Type
                        </option>
                        <option value="Walk-in">Walk-in</option>
                        <option value="Pre-Booked">Pre-Booked</option>
                        <option value="Online"> Online</option>
                      </Form.Select>
                      <ErrorMessage
                        name="bookingType"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-4">
                    <Form.Group className="mb-3" controlId="source">
                      <Form.Label>Branch</Form.Label>
                      <Form.Select
                        placeholder="Select Branch"
                        className="shadow-none focus:!border-theme-dark"
                        name="branch"
                        value={values.branch}
                        onChange={(e) => handleBranchChange(e, setFieldValue)}
                      >
                        <option value="" disabled selected>
                          Select Branch
                        </option>{' '}
                        {/* Default placeholder option */}
                        {leadData?.allBranch?.data?.Branches?.map((res) => {
                          return (
                            <option key={res._id} value={res.branchName} >
                              {res.branchName}
                            </option>
                          );
                        })}
                      </Form.Select>
                    </Form.Group>
                  </div>

                  <div className="col-md-4">
                    <Form.Group className="mb-3" controlId="source">
                      <Form.Label>Branch Address</Form.Label>
                      <Form.Control as='textarea' className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px] shadow-none" placeholder='Enter address' name='branchAddress' value={values.branchAddress} onChange={(e) => setFieldValue('branchAddress', e.target.value)} />
                    </Form.Group>
                  </div>

                  <div className="col-md-4">
                    <Form.Group className="mb-3" controlId="source">
                      <Form.Label>Doctor</Form.Label>
                      <div className="relative">
                        <input
                          name="doctorName"
                          placeholder={values.doctorName || 'Select Doctor'}
                          value={values.doctorName}
                          readOnly
                          className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                          onClick={() => {
                            setDoctorData1(!doctorData1);
                            setSearchType('doctor');
                          }}
                        />

                        <div
                          className={`${doctorData1
                            ? 'opacity-100 visible'
                            : 'opacity-0 invisible'
                            } absolute w-full border top-full h-[180px] z-10 overflow-auto left-0 rounded p-2 bg-white`}
                        >
                          <input
                            type="text"
                            name="search"
                            value={searchQuery}
                            placeholder={`Search Doctors`}
                            onChange={(e) => {
                              setFieldValue('doctor', e.target.value)
                              searchData(e, setFieldValue);
                            }}
                            className="w-full border p-2 rounded outline-none"
                          />
                          {leadData?.allDoctor?.data?.doctor?.map((res) => (
                            <p
                              key={res._id}
                              onClick={() => {
                                setFieldValue('doctorName', res.name);
                                setDoctorData1(false);
                                setSearchQuery('');
                                setSelectedDoctorId(res._id)
                                setSearchDefault({ page: '', search: '' });
                              }}
                              className="text-gray-700 py-1 cursor-pointer"
                            >
                              {res.name}
                            </p>
                          ))}
                        </div>
                      </div>
                    </Form.Group>
                  </div>

                  <div className="col-md-4">
                    <Form.Group className="mb-3" controlId="problem">
                      <Form.Label>Sub Refence</Form.Label>
                      <Form.Control
                        type="text"
                        name="subReference"
                        onChange={(e) => setFieldValue('subReference', e.target.value)}
                        value={values.subReference}
                        placeholder="Enter Sub Refence"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="subReference"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-4">
                    <Form.Group className="mb-3" controlId="problem">
                      <Form.Label>Remark</Form.Label>
                      <Form.Control
                        type="text"
                        name="remark"
                        onChange={(e) => setFieldValue('remark', e.target.value)}
                        value={values.remark}
                        placeholder="Enter Remark"
                        className="shadow-none focus:!border-theme-dark"
                      />
                    </Form.Group>
                  </div>

                  <div className="col-md-4">
                    <Form.Group className="mb-3 " controlId="notify">
                      <Form.Label>Notification</Form.Label>
                      <div className="flex gap-3">
                        <Form.Check
                          type="checkbox"
                          label="Whatsapp"
                          name="notification"
                          value="Whatsapp"
                          checked={values?.notification?.includes('Whatsapp')}
                          id="whatsapp"
                          onChange={(e) => {
                            if (e.target.checked) {
                              setFieldValue('notification', [...values.notification, 'Whatsapp']);
                            } else {
                              setFieldValue('notification', values.notification.filter(n => n !== 'Whatsapp'));
                            }
                          }}
                        />
                        <Form.Check
                          type="checkbox"
                          label="Text"
                          name="notification"
                          value="Text"
                          checked={values?.notification?.includes('Text')}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setFieldValue('notification', [...values.notification, 'Text']);
                            } else {
                              setFieldValue('notification', values.notification.filter(n => n !== 'Text'));
                            }
                          }}
                          id="text"

                        />
                        <Form.Check
                          type="checkbox"
                          label="Email"
                          name="notification"
                          value="email"
                          checked={values?.notification?.includes('email')}
                          id="email"
                          onChange={(e) => {
                            if (e.target.checked) {
                              setFieldValue('notification', [...values.notification, 'email']);
                            } else {
                              setFieldValue('notification', values.notification.filter(n => n !== 'email'));
                            }
                          }}
                        />
                      </div>
                      <ErrorMessage name="notification" component="div" className="text-danger" />
                    </Form.Group>
                  </div>
                </div>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={closeToggle}
                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                  >
                    Close
                  </Button>
                  <Button
                    type="submit"
                    className="!bg-theme-dark border-0 px-4"
                  >
                    Add
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AppoinmentModel;
